import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker'
import { buildSearchContext } from './frontPageEvents'
import { SearchEventData } from 'contexts/GlobalSearch/GlobalSearchTracking'

export function trackSearchEvent(subject: string, category: string, data: SearchEventData) {
  const { searchItem, checkIn, checkOut, vertical, isFlexibleDates, occupancies } = data
  const baseContext = buildSearchContext()

  const formattedOccupancies = (occupancies ?? []).map(
    occupants => ({ numberOfChildren: (occupants?.infants ?? 0) + (occupants?.children ?? 0), numberOfAdults: occupants.adults }))

  const context = {
    ...baseContext,
    searchType: searchItem?.searchType ?? '',
    verticals: [vertical],
    searchParams: {
      ...baseContext.searchParams,
      checkIn: checkIn ?? null,
      checkOut: checkOut ?? null,
      occupancies: formattedOccupancies,
      isFlexibleDates: Boolean(isFlexibleDates),
    },
  }

  const searchContext = comluxgroup.createSearch_1_0_0(context)

  const rawEvent: comluxgroup.ClientEvent_1_0_0 = {
    action: 'clicked',
    subject,
    type: 'interaction',
    category,
  }

  const event = comluxgroup.createClientEvent_1_0_0(rawEvent)

  trackSelfDescribingEvent({
    context: [searchContext],
    event,
  })
}
